/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="74.97" height="95.59" viewBox="0 0 74.97 95.59" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <defs>
          <mask id="fcd97266-737b-48b9-99b8-b9b6750f80da" x="0" y="0" width="74.97" height="95.59" maskUnits="userSpaceOnUse">
            <g transform="translate(-40 -30)">
              <polygon points="40 125.59 114.97 125.59 114.97 30 40 30 40 125.59" fill="#fff" fillRule="evenodd"/>
            </g>
          </mask>
        </defs>
        <g>
          <g>
            <path d="M112.55,30.81l2.34.88-10.6,28a1.24,1.24,0,0,1-1,.81H51.84a1.25,1.25,0,0,1-1.11-.69l-.06-.12-10.59-28,2.34-.88L52.71,58h49.55Z" transform="translate(-40 -30)" fill="#0e497b"/>
            <g mask="url(#fcd97266-737b-48b9-99b8-b9b6750f80da)">
              <path d="M113.72,30H41.25A1.25,1.25,0,0,0,40,31.25v93.09a1.25,1.25,0,0,0,1.25,1.25h72.47a1.25,1.25,0,0,0,1.25-1.25V31.25A1.25,1.25,0,0,0,113.72,30Zm-1.25,2.5v90.59h-70V32.5Z" transform="translate(-40 -30)" fill="#0e497b"/>
            </g>
          </g>
          <path d="M77.48,77.63v0Z" transform="translate(-40 -30)" fill="#094d77" fillRule="evenodd"/>
          <polygon points="38.48 15.5 38.48 47.63 36.48 47.63 36.48 15.5 38.48 15.5" fill="#0e497b"/>
          <g>
            <path d="M76.38,52.6a5.65,5.65,0,1,0-4.44-4.44,5.66,5.66,0,0,0,4.44,4.44" transform="translate(-40 -30)" fill="#0e497b" fillRule="evenodd"/>
            <path d="M71.82,48.19a6,6,0,1,0,0-.22Zm6.74-6.55a5.52,5.52,0,1,1-6.49,6.5A5.51,5.51,0,0,1,78.56,41.64Z" transform="translate(-40 -30)" fill="#0e497b"/>
            <path d="M76.38,83.39A5.65,5.65,0,1,0,71.94,79a5.66,5.66,0,0,0,4.44,4.44" transform="translate(-40 -30)" fill="#ffb81c" fillRule="evenodd"/>
            <path d="M71.82,79a6,6,0,1,0,0-.22Zm6.74-6.55a5.53,5.53,0,1,1-6.49,6.5A5.53,5.53,0,0,1,78.56,72.43Z" transform="translate(-40 -30)" fill="#ffb81c"/>
          </g>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'InnerOfficeEnvelopeFastenedWithStringIcon';

export default Icon;
